














































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService, SkcServerService } from "src/services";
import { IServerModel } from "src/model";
import router from '../../router';
import { ServiceType, DurationUnitType } from "src/enums";
import { EnumUtils } from "src/utils";

@Component
export default class Shop extends Vue
{
    /**
     * 获取平台服务
     * @private
     * @return SkcServerService
     */
    private _skcServerService: SkcServerService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerService(): SkcServerService
    {
        if(!this._skcServerService)
        {
            this._skcServerService = this.$serviceProvier.resolve<SkcServerService>(SkcServerService);
        }

        return this._skcServerService;
    }

    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 弹框显示
     * @protected
     * @returns 
     */
    protected visible: boolean = false;

    /**
     * 机构列表
     * @protected
     * @returns 
     */
    protected dataList: Array<IServerModel> = [];

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取套餐名称
     * @protected
     */
    protected getDurationUnitTypeName(value: number):string
    {
        return EnumUtils.getEntry(value,DurationUnitType)?.alias || "";
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }


    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
       this.getServerList();
    }

    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }
    /**
   * 购买当前版本
   * @protected
   * @return void
   */
  protected payThis(item:IServerModel): void {
      this.$router.push({name:'version-shoppingCart', query: {id: item.id.toString()}})
  }

    /**
   * 获取版本信息
   * @protected
   * @return void
   */
  protected async getServerList(): Promise<void> {
       try
        {
           let {content: res} = await this.skcServerService.skcServerPageList({serverType: ServiceType.BasicServer});
           if (res && res.data)
           {
               this.dataList = res.data;
           }
        }
        catch (err)
        {
            this.$message.error({
                duration: 3,
                content: err || "服务器错误",
            });
        }
  }
  

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
            title: "提示",
            content: "是否确定注销登录 ?",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                return await this.logout()
                .then(() => {
                    setTimeout(() => {
                        localStorage.clear();
                        this.$router.push("/")
                    }, 20);
                })
                .catch(() => {
                    this.$message.error("注销失败");
                });
            },
            onCancel() {},
        });
    }
     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
}
